<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="add parameters">
      <v-card-actions>
        <a @click="$router.back()">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
            <v-icon left>mdi-arrow-left</v-icon>back
          </v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1"
            class="mr-n2 mt-10" style="opacity:.6;">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </a>
      </v-card-actions>
      <v-card-component>
        <form autocomplete="off" @submit.prevent="save">
          <v-row>
            <v-col cols="12" md="12">
              <label class="font-weight-medium body-2">
                Parameter's
              </label>
              <div v-for="(n, i) of prmtr" :key="i">
                <v-card-component>
                  <v-row>
                    <v-col cols="12" md="11" class="pt-0 pb-0">
                      <v-row>
                        <v-col cols="12" md="2">
                          <label class="font-weight-medium body-2">
                            Position
                          </label>
                          <v-text-field title="Position" class="my-0 py-1" min="1" type="number"
                            placeholder="Position" v-model.trim="prmtr[i].position" maxlength="100">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="5">
                          <label class="font-weight-medium body-2">
                            Parameter Name
                          </label>
                          <v-text-field class="my-0 py-1" counter="100" placeholder="Parameter name"
                            :required="i === 0" v-model.trim="prmtr[i].parameterName"
                            maxlength="100" title="Enter valid character">
                          </v-text-field>
                        </v-col>

                      </v-row>
                    </v-col>
                    <v-col cols="12" md="1"
                      class="d-flex pt-0 pb-0 flex-column justify-center align-center">
                      <label class="font-weight-medium body-2">No. {{ i + 1 }}</label>

                      <v-card-actions>
                        <v-btn title="Delete parameter" elevation="1" color="error"
                          @click="deleteRow(i, prmtr[i])">
                          <v-icon left> mdi-trash-can </v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-col>
                  </v-row>
                </v-card-component>
              </div>
              <v-card-actions class="d-flex justify-end">
                <v-btn bottom right elevation="1" color="primary" @click="
                    prmtr.push({
                      auditSubCategoryID: subcategoryId,
          parameterName: '',
         // responses: '',
          position: '',
          isActive: true
                    })
                  ">
                  <v-icon left> mdi-plus </v-icon>
                  Add Parameter
                </v-btn>
              </v-card-actions>
            </v-col>

            <v-col cols="12">
              <v-card-actions class="d-flex justify-end">
                <v-btn bottom right elevation="1" color="primary" type="submit">
                  <v-icon left> mdi-content-save </v-icon>
                  Save all
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </form>
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'
// import { mapGetters } from 'vuex'
import _ from 'lodash'
// import Utils from '@/utils'

import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'

export default {
  components: { VCardComponent, MaterialCard },
  props: ['subcategoryId'],
  data () {
    return {
      name: '',
      remark: '',
      desc: '',
      selectedAcademicYear: '',
      position: 0,
      classList: [],
      classSelectAll: false,
      classIds: [],
      academicYears: [],
      showParam: false,
      // responseType: '',
      prmtr: [
        {
          auditSubCategoryID: this.subcategoryId,
          parameterName: '',
          // responses: '',
          position: '',
          isActive: true
        }
      ],

      catType: '',
      isEdit: false,
      deleteParameters: []
    }
  },
  created: async function () {
    // await this.getClassList()
    // await this.getYear()
    // if (this.categoryId) {
    //   this.isEdit = true
    //   await this.getCategoryDetails()
    // }
  },
  watch: {},
  methods: {
    save: async function () {
      console.log(this.prmtr, 'test')

      try {
        if (this.validateForm()) {
          let formData = {
            parameters: this.prmtr
          }
          let res = await http.post(`${CONSTANTS.API_URL}/api/audit/audit-parameter/add`, formData)
          this.okMsg(res.data)
          this.$router.push({ name: 'generalParameterList' })
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    validateForm () {
      if (this.prmtr[0].parameterName === '' || this.prmtr[0].parameterName === undefined) {
        this.errMsg('Name cannot be empty!')
      } else {
        return true
      }
    },
    deleteParameter: async function (parameterId) {
      try {
        let res = await http.get(`${CONSTANTS.API_URL}/api/center-audit/parameter/status/${parameterId}`)
        console.log('Delete parameter response: ', res)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },

    deleteMultipleParameters: async function (arr, isActive = false) {
      try {
        if (arr.length > 0) {
          await http.put(`${CONSTANTS.API_URL}/api/center-audit/parameter/all/status`, {
            parameters: arr,
            isActive: isActive
          })
        }
      } catch (e) {
        console.log(e)
      }
    },

    deleteRow (e, item) {
      if (item.id) {
        this.deleteParameters.push(item.id)
        // this.deleteParameter(item.id)
      }
      if (this.prmtr.length > 1) {
        this.prmtr = _.filter(this.prmtr, (a, b) => b !== e)
      } else {
        this.errMsg('Cannot delete! Atleast one parameter is required!')
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>

<style></style>
